import { type IWidgetDirectiveType } from '../IWidgetDirectiveType.ts';
import {
  type IPdfVisibilityDirective,
  PdfVisibilityDirectiveSchema,
} from './IPdfVisibilityDirective.ts';
import { PdfVisibilityDirectiveConfigComponent } from './PdfVisibilityDirectiveConfigComponent.tsx';

export const PDF_VISIBILITY_META_KEY = 'pdf-visibility';

/**
 * Direttiva per l'esportazione dei metadati di un campo in forma
 * normalizzata.
 */
export const PdfVisibilityDirectiveType: IWidgetDirectiveType<IPdfVisibilityDirective> =
  {
    name: 'pdfVisibility',
    key: 'pdfVisibility',
    allowsWidget: () => true,
    configComponent: PdfVisibilityDirectiveConfigComponent,
    configSchema: PdfVisibilityDirectiveSchema,
    formSchemaModifier: ({ directiveConfig, schema }) => {
      return schema.meta({
        [PDF_VISIBILITY_META_KEY]: directiveConfig.visibility,
      });
    },
    supportedSectionTypes: ['BACKOFFICE', 'FRONTOFFICE'],
  };
